var Cart = function () {
  var self = this;
  this.init = function () {
    document.querySelectorAll(".instacart .checkout__del").forEach((holder) => {
      holder.addEventListener("click", this.deleteCartItem);
    });
    document
      .querySelectorAll(".instacart select.js-choice")
      .forEach((holder) => {
        holder.addEventListener("change", this.updateQuantityDropdown);
      });

      };
  this.updateCustomizationFee = function (element) {
    let newCustomToolItems = false;
    let sku = element.closest(".instacart__item").getAttribute("data-sku");
    if (
      CUSTOMTRAMPOLINES.includes(sku) &&
      document.querySelector(".instacart__list").hasChildNodes()
    ) {
      newCustomToolItems = 0;
      document
        .querySelectorAll(".instacart__list .instacart__item")
        .forEach((item, index) => {
          let csku = item.getAttribute("data-sku");
          let cqty = item.querySelector("select").value;
          console.log(cqty);
          if (CUSTOMTRAMPOLINES.includes(csku)) {
            newCustomToolItems += parseInt(cqty);
          }
        });
      let current_qty = element
        .closest(".instacart__item")
        .querySelector("select").value;
      newCustomToolItems = newCustomToolItems - parseInt(current_qty);
    }
    return newCustomToolItems;
  };
  this.deleteCartItem = function (e) {
    e.preventDefault();
    let variant_id = e.target
      .closest(".instacart__item")
      ?.getAttribute("data-variant");
    let formData = { updates: {} };
    formData.updates[variant_id] = 0;
  
    self.updateLineItem(formData).then((obj) => {
      if (obj.items.length == 0) {
        location.reload();
      }

      if (ctrampolineCount !== false) {
        if (ctrampolineCount == 0) {
          document
            .querySelector(
              '.navbar-cart-list [data-variant="' + customizationFeeID + '"]'
            )
            ?.remove();
          document
            .querySelector(
              '.instacart__list [data-variant="' + customizationFeeID + '"]'
            )
            ?.remove();
        }
      }
      e.target.closest(".instacart__item").remove();
      document.querySelector(".mini-cart-count .badge").innerHTML =
        obj.item_count;
      document.querySelector(".checkout__subtotal-price").innerHTML =
        Shopify.formatMoney(obj.total_price);
      document.querySelector(".checkout__total-price .price").innerHTML =
        Shopify.formatMoney(obj.total_price);
    });
  };
  this.updateQuantityDropdown = function (e) {
    e.preventDefault();
    let variant_id = e.target
      .closest(".instacart__item")
      .getAttribute("data-variant");
    let formData = { updates: {} };
    formData.updates[variant_id] = parseInt(e.target.value);
    
    self.updateLineItem(formData).then((obj) => {
      if (obj.items.length == 0) {
        location.reload();
      }
       
      obj.items.forEach((item, index) => {
        let h_item = document.querySelector(
          '.instacart__list [data-variant="' + item.variant_id + '"]'
        );
        let miniCart = document.querySelector(
          '.navbar-cart-list [data-variant="' + item.variant_id + '"]'
        );
        h_item.querySelector(".price").innerHTML = Shopify.formatMoney(
          item.final_line_price
        );
         
        h_item.querySelector(".checkout__num").innerHTML = item.quantity;
        miniCart.querySelector('select').value =  item.quantity;
       
      });
      document.querySelector(".mini-cart-count .badge").innerHTML =
        obj.item_count;
      document.querySelector(".checkout__subtotal-price").innerHTML =
        Shopify.formatMoney(obj.total_price);
      document.querySelector(".checkout__total-price .price").innerHTML =
        Shopify.formatMoney(obj.total_price);
      self.updateMetaFields(
        e.target.closest(".instacart__item"),
        variant_id,
        e.target.value
      );
    });
  };

  this.updateMetaFields = function (target, variant_id, quantity) {
    fetch("/cart?view=metafields.json")
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .then((obj) => {
        obj.items.forEach((item, index) => {
          if (
            item.variant_id == variant_id &&
            target.querySelector(".checkout__old-price")
          ) {
            target.querySelector(".checkout__old-price").innerHTML =
              Shopify.formatMoney(item.compare_at_price * quantity);
          }
        });
      });
  };

  this.updateLineItem = function (formData) {
    return new Promise(function (resolve, reject) {
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .then((obj) => {
          resolve(obj);
        });
    });
  };
  this.init();
};
new Cart();